<!--login  code== 302填写完学籍卡但未提交人工审核页面 -->
<template>
    <div>
        <div>
            <img class="failImg" src="./images/btn_shibai_nor@3x.png"/>
            <div class="com-text short-text">{{ isManualFail ? '人工认证失败' : '自动认证失败' }}</div>
            <div v-if="authenticationReason" class="reason">{{ isManualFail ? '驳回原因' : '认证失败原因' }}：{{ authenticationReason }}</div>
            <div class="com-text long-text">
                <template v-if="isManualFail">
                    如有疑问，请致电024-31975882获取帮助
                    <el-button class="call-work" type="primary" @click="contact">点击拨打工作人员电话 024-31975882</el-button>
                </template>
                <template v-else>
                    很抱歉，校友认证数据比对失败，您可以申请人工审核，上传更多信息有助于审核通过
                </template>
            </div>
            <!-- <div style="height: 160px;"></div> -->
            <el-button style="display: block;margin: 0 auto; margin-top: 10px;" class="lwork" type="primary" @click="applyLabor">{{ isManualFail ? '补充材料' : '申请人工认证' }}</el-button>
            <el-button style="display: block;margin: 0 auto; margin-top: 15px;" class="hwork" type="text" @click="backInfo">返回修改基础信息</el-button>
        </div>
        <!-- 弹窗 -->
        <div>
            <van-popup v-model="drawer" round position="bottom" :style="{ height: '30%' }">
                <div style="border-bottom: 1px solid #DFDFDF;" class="com-item">工作人员联系电话</div>
                <a :href="'tel:02431975882'">
                    <div style="border-bottom: 1px solid #DFDFDF;" class="com-item">024-31975882</div>
                </a>
                <div class="com-item" @click="drawer = false">取消</div>
            </van-popup>
        </div>
    </div>
</template>

<script>
export default{
    data(){
        return{
            authentication: Number(this.$route.query.authentication),
            authenticationReason: this.$route.query.authenticationReason || "",
            drawer: false,
        }
    },
    computed: {
        isManualFail() {
            return this.authentication === 4;
        },
    },
    methods:{
        applyLabor(){
            this.$router.push("/addCertification");
        },
        contact() {
            this.drawer = true;
        },
        backInfo(){
            this.$router.push("/UserData");
        }
    }
}

</script>

<style lang="less">
.el-button--primary {
    color: #fff;
    background-color: #409eff;
    border-color: #409eff;
    margin: auto;
}
.el-button+.el-button {
    margin: auto;
}
.failImg{
    border-radius: 50%;
    height: 200px;
    width: 250px;
    border-radius: 50%;
    display: block;
    margin: 25px auto;
}
.com-text{
    margin: 10px auto;
    text-align: center;
    color: #333333;
}
.short-text{
    font-size: 20px;
}
.long-text{
    width: 80%;
    margin-top: 90px;
}
.call-work {
    width: 100%;
    height: 40px;
    border-radius: 35px;
    background: #ffffff;
    color: #00706E;
    border: 1px solid #00706E;
    font-size: 1rem;
    padding: 0;
}
.reason{
    margin: 10px auto 0;
    color: #666666;
    text-align: center;
    width: 80%;
    word-break: break-all;
}
.lwork{
    width: 80%;
    background-color: #00706E;
    height: 35px;
    font-size: 20px;
    color: #fff;
    margin: auto;
    border-radius: 35px;
    padding: 0;
}

.hwork{
    color: #333333;
    margin: 15px auto;
    text-align: center;
    width: 80%;
}
.el-button+.el-button{
    margin: auto;
    margin-left: 20%;
}
// 底部弹出层
.com-item {
    text-align: center;
    font-size: 1.2rem;
    padding: 20px 0;
}

a {
    color: #333333;
}
</style>



// WEBPACK FOOTER //
// src/components/IdentitAuthentication/failAuthentication.vue